import styled, { css } from 'styled-components';

interface ContainerProps {
  backgroundColor?: string;
  primaryBackgroundColor?: string;
  textAlign?: string;
  fontWeight?: string | number;
  color?: string;
  percentage?: null | number;
}

export const Container = styled.div<ContainerProps>`
  width: 100%;
  height: 100% !important;
  height: min-content;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-self: center;
  margin: 0 4px;

  ${({
    backgroundColor,
    primaryBackgroundColor,
    textAlign,
    fontWeight,
    color,
    percentage,
  }) =>
    css`
      color: ${color || '#000000'};
      text-align: ${textAlign || 'right'};
      font-weight: ${fontWeight || 'normal'};
      background: linear-gradient(
        to right,
        ${backgroundColor || '#0DB2D6'} ${percentage}%,
        ${primaryBackgroundColor} 0%
      );
    `}
`;
